import { handleInventory, handleInventoryBatch, handleInventoryBatches, handleListingsDetails, handleListings } from '../helpers/routes'

// The hub's page on Inventory and its saved views: the first of these steps still to do, both of which start there.
const INVENTORY_HELP = ['add-cards', 'list-cards']

export default [
  {
    path: '/inventory',
    name: 'Inventory',
    meta: { requireAuth: true, requireFields: true, help: INVENTORY_HELP },
    component: () => import('@/views/Inventory/index.vue'),
    beforeEnter: handleInventory
  },
  {
    path: '/inventory/views',
    name: 'InventoryViews',
    meta: { requireAuth: true, requireFields: true, help: INVENTORY_HELP },
    component: () => import('@/views/Inventory/Views.vue'),
  },
  {
    path: '/inventory/views/:viewId',
    name: 'InventoryViewDetails',
    component: () => import('@/views/Inventory/index.vue'),
    meta: { requireAuth: true, requireFields: true, help: INVENTORY_HELP },
    beforeEnter: handleInventory,
  },
  {
    // All batches, inside Inventory (new-design only). Must precede any
    // /inventory/:param route, or "batches" gets read as a card id.
    path: '/inventory/batches',
    name: 'InventoryBatches',
    // The hub's page here: the step that starts by picking a batch.
    meta: { requireAuth: true, requireFields: true, help: 'review-cards' },
    component: () => import('@/views/InventoryBatches/index.vue'),
    beforeEnter: handleInventoryBatches,
  },
  {
    // Batch-in-inventory (new-design only). Placed before /inventory/:cardId so
    // the two-segment path is unambiguous; guarded by new_design. Children mirror
    // the batch route nesting: they all point to the same InventoryBatch component
    // (which has no <router-view>), so the parent stays mounted while :cardId/:tab
    // params + route.name update — the Inspector's card-to-card navigation.
    path: '/inventory/batch/:batchId',
    component: () => import('@/views/InventoryBatch/index.vue'),
    // The grid's page; the Inspector and a card's details below name their own.
    meta: { requireAuth: true, requireFields: true, help: 'overview-mode' },
    beforeEnter: handleInventoryBatch,
    children: [
      { path: '', name: 'InventoryBatch', component: () => import('@/views/InventoryBatch/index.vue') },
      {
        path: 'inspector',
        component: () => import('@/views/InventoryBatch/index.vue'),
        meta: { help: 'inspector-mode' },
        children: [
          { path: '', name: 'InventoryBatchInspector', component: () => import('@/views/InventoryBatch/index.vue') },
          { path: ':cardId', name: 'InventoryBatchInspectorCard', component: () => import('@/views/InventoryBatch/index.vue') },
        ],
      },
      {
        path: ':cardId',
        component: () => import('@/views/InventoryBatch/index.vue'),
        meta: { help: 'edit-card-details' },
        children: [
          { path: '', name: 'InventoryBatchByCard', component: () => import('@/views/InventoryBatch/index.vue') },
          { path: ':tab', name: 'InventoryBatchByCardTab', component: () => import('@/views/InventoryBatch/index.vue') },
        ],
      },
    ],
  },
  {
    path: '/inventory/:cardId',
    name: 'InventoryDetails',
    meta: { requireAuth: true, requireFields: true, help: 'edit-card-details' },
    component: () => import('@/views/InventoryDetails/index.vue'),
  },
  {
    path: '/listings/:connection/:cardId',
    meta: { requireAuth: true, requireFields: true, help: 'explore-listings' },
    name: 'ListingsDetails',
    component: () => import('@/views/ListingsDetails/index.vue'),
    sensitive: true,
    beforeEnter: handleListingsDetails,
  },
  {
    path: '/listings',
    name: 'Listings',
    // The hub's page here and on each marketplace's listings below.
    meta: { requireAuth: true, requireFields: true, help: 'explore-listings' },
    component: () => import('@/views/Listings/index.vue'),
    beforeEnter: handleListings,
    children: [
      {
        path: ':connection',
        component: () => import('@/views/Listings/ListingsByConnection.vue'),
        sensitive: true,
        name: 'ListingsByConnection',
      }
    ]
  }
]
